export const ActionTypes = {
  FETCH_SILOS_GRID: 'services/dashboards/silosDashboard/fetch_silos_grid',
  SET_SILOS_GRID: 'services/dashboards/silosDashboard/set_silos_grid',
  SET_LOADER_STATUS: 'services/dashboards/silosDashboard/set_loader_status',
};
const fetchSilosGrid = ({ silosParams }) => ({
  silosParams,
  type: ActionTypes.FETCH_SILOS_GRID,
});

const setSilosGrid = ({ silosGrid }) => ({
  silosGrid,
  type: ActionTypes.SET_SILOS_GRID,
});

const setLoader = ({ showLoader }) => ({
  showLoader,
  type: ActionTypes.SET_LOADER_STATUS,
});

export default {
  fetchSilosGrid,
  setSilosGrid,
  setLoader,
};
